import { FLOWERAI_CLOUD_ML_MODEL } from '../constants/urls'

export const LOAD_TF_MODEL = 'LOAD_TF_MODEL'
export function loadTFModel() {
    return {
        type: LOAD_TF_MODEL,
        payload: window.tf.loadModel(FLOWERAI_CLOUD_ML_MODEL),
    }
}

export const SET_CLASSIFY_IMAGE = 'SET_CLASSIFY_IMAGE'
export function setClassifyImage(image) {
    return {
        type: SET_CLASSIFY_IMAGE,
        payload: image,
    }
}

export const RESET_CLASSIFY_IMAGE = 'RESET_CLASSIFY_IMAGE'
export function resetClassifyImage() {
    return {
        type: RESET_CLASSIFY_IMAGE,
        payload: null,
    }
}

export const CLASSIFY_PLANT = 'CLASSIFY_PLANT'
export function classifyPlant(model, image) {
    const img = new Image(299, 299)
    img.src = image

    let tfImage = window.tf.fromPixels(img, 3)
    tfImage = tfImage.reshape([1, 299, 299, 3])
    tfImage = window.tf.cast(tfImage, 'float32')

    const tensorDiv = window.tf.scalar(255.0)
    const tensorSub = window.tf.scalar(0.5)
    const tensorMul = window.tf.scalar(2.0)
    tfImage = window.tf.div(tfImage, tensorDiv)
    tfImage = window.tf.sub(tfImage, tensorSub)
    tfImage = window.tf.mul(tfImage, tensorMul)

    const prediction = model.predict(tfImage, { batchSize: 1 })

    return {
        type: CLASSIFY_PLANT,
        payload: prediction.data(),
    }
}



// WEBPACK FOOTER //
// ./src/actions/classifier.js